import { render, staticRenderFns } from "./oftahistory.vue?vue&type=template&id=8d069b86&scoped=true&"
import script from "./oftahistory.vue?vue&type=script&lang=js&"
export * from "./oftahistory.vue?vue&type=script&lang=js&"
import style0 from "./oftahistory.vue?vue&type=style&index=0&id=8d069b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d069b86",
  null
  
)

export default component.exports